var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":"","grid-list-xs":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('h1',[_vm._v("404 NOT FOUND")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }